<template>
  <v-dialog
    fullscreen
    eager
    v-model="dialog"
    hide-overlay
    content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-card-text v-show="showComponent" v-if="isAdmin">
        <AdminForm
          ref="adminForm"
          :edit="edit" />
      </v-card-text>
      <v-card-text fluid class="centered-tabs mt-3 mx-1" v-show="showComponent" v-else>
        <UserForm
          ref="userForm"
          :edit="edit" />
      </v-card-text>

      <v-card-text fluid class="centered-tabs mt-3 mx-1" v-show="showComponent" >
        <v-col cols="12">
          <v-card
            elevation="0"
            flat
            tile
            class="pl-3 pt-3 pb-md-3"
          >
            <TwoButtonDialog
              ref="saveButton"
              :btn-text="$t('buttons:save')"
              color="primary"
              :hideOverlay="true"
              :dialog-title="$t('dialog:save-btn-title', {name : $t('display/advert:edit.dialogs.dialog-part-1')})"
              :dialog-text="$t('dialog:save-btn-dialog', {name : $t('display/advert:edit.dialogs.dialog-part-2')})"
              :button1-text="$t('buttons:save')"
              :button2-text="$t('buttons:cancel')"
              @clickedButton1="updateForm()"
              @clickedButton2="$refs.saveButton.showDialog = false"
            />
            <DirtyConfirmButtonDialog
              ref="dirtyDialog"
              :btn-text="$t('buttons:back')"
              color="grey"
              :hideOverlay="true"
              :dialog-title="$t('dialog:dirty-save-btn-title')"
              :dialog-text="$t('dialog:dirty-save-btn-dialog')"
              :button1-text="$t('dialog:dirty-save-btn-1-text')"
              :button2-text="$t('dialog:dirty-save-btn-2-text')"
              @clickedButton="closeDialog()"
            />
          </v-card>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {Role} from "@/modules/core/data/roles";
import Advert from '@/modules/display/data/advert';
import AdvertService from '@/modules/display/services/advert-service';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';

import Utils from '@/modules/core/services/utils';
import AdminForm from './form/AdminForm';
import UserForm from './form/UserForm';

export default {
  name: 'AdvertForm',
  components: {
    UserForm,
    AdminForm,
    TwoButtonDialog,
    DirtyConfirmButtonDialog
  },
  data() {
    return {
      dialog: false,
      advert: new Advert(),
      advertBeforeChange: new Advert(),
      restTags: [],
      edit: false,
      isFetchingAdvert: true
    }
  },
  computed: {
    showComponent() {
      if (this.edit) {
        if (this.isFetchingAdvert) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },

    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    isDataChanged() {
      if (this.advert === null
        || this.advertBeforeChange === null) {
        return false;
      }


      let actualAdvert = Object.assign({}, this.advert);
      let advertBeforeChange = Object.assign({}, this.advertBeforeChange);
      actualAdvert.tags = [];
      actualAdvert.blackTags = [];
      actualAdvert.excludedElevator = [];
      actualAdvert.specificElevator = [];
      actualAdvert.selectedRegions = [];

      advertBeforeChange.tags = [];
      advertBeforeChange.blackTags = [];
      advertBeforeChange.excludedElevator = [];
      advertBeforeChange.specificElevator = [];
      advertBeforeChange.selectedRegions = [];

      this.advert.tags = this.advert.tags === null ? [] : this.advert.tags;
      this.advert.blackTags = this.advert.blackTags === null ? [] : this.advert.blackTags;
      this.advertBeforeChange.tags = this.advertBeforeChange.tags === null ? [] : this.advertBeforeChange.tags;
      this.advertBeforeChange.blackTags = this.advertBeforeChange.blackTags === null ? [] : this.advertBeforeChange.blackTags;

      if (JSON.stringify(advertBeforeChange) !== JSON.stringify(actualAdvert)
        || this.advert.tags.length !== this.advertBeforeChange.tags.length
        || this.advert.blackTags.length !== this.advertBeforeChange.blackTags.length
      ) {
        return true;
      }

      for (let i = 0; i < this.advert.tags.length; i++) {
        if (this.advertBeforeChange.tags.indexOf(this.advert.tags[i].id) < 0) {
          return true;
        }
      }

      for (let i = 0; i < this.advert.blackTags.length; i++) {
        if (this.advertBeforeChange.blackTags.indexOf(this.advert.blackTags[i].id) < 0) {
          return true;
        }
      }

      for (let i = 0; i < this.advert.excludedElevator.length; i++) {
        if (this.advertBeforeChange.excludedElevator.indexOf(this.advert.excludedElevator[i].id) < 0) {
          return true;
        }
      }

      for (let i = 0; i < this.advert.specificElevator.length; i++) {
        if (this.advertBeforeChange.specificElevator.indexOf(this.advert.specificElevator[i].id) < 0) {
          return true;
        }
      }

      return false;
    },

    closeDialog(updateTable) {
      this.dialog = false;
      if (updateTable === true) {
        this.$emit("updateTable");
      }
    },

    updateForm() {
      if ((this.isAdmin && !this.$refs.adminForm.validate())
          || (!this.isAdmin && !this.$refs.userForm.validate())
      ) {
        this.$refs.saveButton.showDialog = false;
        // TODO scroll to specific form field which doesnt require the rules
        window.scrollTo(0, 0);
        return;
      }
      let advertToSave = Object.assign({}, this.advert);
      advertToSave.regions = JSON.stringify(this.advert.selectedRegions);
      advertToSave.media = null;

      if (typeof advertToSave.buttonContent === 'undefined' || advertToSave.buttonContent === '') {
        advertToSave.buttonContent = null;
      }

      if (typeof advertToSave.advertDirection === 'undefined' || advertToSave.advertDirection === '') {
        advertToSave.advertDirection = null;
      }

      if (typeof advertToSave.budget === 'undefined' || advertToSave.budget === '') {
        advertToSave.budget = null;
      }

      if (typeof advertToSave.advertType === 'undefined' || advertToSave.advertType === '') {
        advertToSave.advertType = null;
      } else {
        advertToSave.advertType = advertToSave.advertType.toUpperCase();
      }

      if(!this.isAdmin)
        advertToSave.specificElevator = this.$refs.userForm.elevatorIds;

      this.$refs.saveButton.setButtonSettings(true, true, false, true);
      if (this.edit) {
        AdvertService.putToAPI(advertToSave,
          () => {
            this.closeDialog(true);
            Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('common:media_plural')}));
            this.$refs.saveButton.showDialog = false;
            this.$refs.saveButton.setButtonSettings(false, false, false, false);
          },
          () => {
            this.$refs.saveButton.setButtonSettings(false, false, false, false);
            Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('common:media_plural')}))
          }
        );
      } else {
        AdvertService.postToAPI(advertToSave,
          () => {
            this.closeDialog(true);
            Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:media_plural')}));
            this.$refs.saveButton.showDialog = false;
            this.$refs.saveButton.setButtonSettings(false, false, false, false);
          },
          () => {
            this.$refs.saveButton.setButtonSettings(false, false, false, false);
            Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('common:media_plural')}))
          }
        );
      }
    },

    resetDefaultData() {
      this.advert = new Advert();
      this.advertBeforeChange = new Advert();
      this.edit = false;
      this.isFetchingAdvert = true;

      if (this.isAdmin) {
        this.$refs.adminForm.resetDefaultData();
      }
    },

    readAdvert(id) {
      AdvertService.readFromAPI(
          id,
          (response) => {
            this.$refs.dirtyDialog.setDirty(false);
            this.edit = true;
            this.advert = response.data;

            this.advert.provision = this.advert.provision > 0 ? this.advert.provision *= 100 : 0.0;
            this.advert.budget = this.advert.budget > 0 ? this.advert.budget : 0;
            this.advert.mediaLength = this.advert.mediaLength > 0 ? this.advert.mediaLength : 10;
            this.advertBeforeChange = Object.assign({}, this.advert);
            this.isFetchingAdvert = false;

            if (this.isAdmin) {
              this.initializeForAdminFrom();
            } else {
              this.$refs.userForm.initialize(this.advert);
            }

            this.$watch('advert',
              () => {
                this.$refs.dirtyDialog.setDirty(this.isDataChanged())
              },
              {deep: true}
            );
          }
      )
    },

    initialize(advert) {
      this.resetDefaultData();
      if (!!advert && !!advert.id) {
        this.readAdvert(advert.id);
      } else {
        this.$nextTick(() => {
          this.setValueForNewAdvert();
          if (this.isAdmin) {
            this.$refs.adminForm.initialize(this.advert);
          } else {
            this.$refs.userForm.initialize(this.advert, true);
          }
        });
      }
      this.dialog = true;
    },
    initializeById(advertId) {
      this.resetDefaultData();
      if (advertId) {
        this.readAdvert(advertId);
        this.dialog = true;
      }
    },
    initializeForAdminFrom() {
      this.advertBeforeChange.tags = [].concat(this.advert.tags);
      this.advertBeforeChange.blackTags = [].concat(this.advert.blackTags);
      this.advertBeforeChange.specificElevator = [].concat(this.advert.specificElevator);
      this.advertBeforeChange.excludedElevator = [].concat(this.advert.excludedElevator);

      this.$refs.adminForm.initialize(this.advert);
    },
    setValueForNewAdvert() {
      let today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth() + 1;
      let day = today.getDate();
      let dayStart = `${day.toString().padStart(2, '0')}.${month.toString().padStart(2, '0')}.${year}`;
      let dayEnd = `${day.toString().padStart(2, '0')}.${month.toString().padStart(2, '0')}.${year + 1}`;

      this.advert.dateStart = dayStart;
      this.advert.dateEnd = dayEnd;
      this.advert.provision = '0.0';
      this.advert.budget = '0';
      this.advert.mediaLength = '10';

      this.advert.timeStart = '00:00';
      this.advert.timeEnd = '23:59';

      this.advertBeforeChange = Object.assign({}, this.advert);
      this.$watch('advert',
        () => {
          this.$refs.dirtyDialog.setDirty(this.isDataChanged());
        },
        {deep: true}
      );

    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.hash) {
        vm.$store.commit('display/routes/storeLastMainRoute', from.path + from.hash);
      } else {
        vm.$store.commit('display/routes/storeLastMainRoute', from.path);
      }
    });
  },

  watch: {
    dialog() {
      if(!this.dialog) {
        if (this.isAdmin) {
          this.$refs.adminForm.reset();
        } else {
          this.$refs.userForm.reset();
        }

        this.edit = false;
      }
    }
  }

}
</script>

<style lang="scss" scoped>
/*
  had to set z-index of dialog and overlay manually here
  because here we have a single case of dialog over dialog
*/
.v-dialog__content.v-dialog__content--active {
  z-index: 500 !important;
}
</style>
